import enGB from './en-GB.json';
import ruRU from './ru-RU.json';
import enUS from './en-US.json';
import esMX from './es-MX.json';
import frFR from './fr-FR.json';
import itIT from './it-IT.json';
import jaJP from './ja-JP.json';
import koKR from './ko-KR.json';
import ptBR from './pt-BR.json';
import zhCN from './zh-CN.json';
import zhHK from './zh-HK.json';
import deAT from './de-AT.json';
import deDE from './de-DE.json';

const localeMap: { [key: string]: object } = {
  'en-GB': enGB,
  'ru-RU': ruRU,
  'en-US': enUS,
  'es-MX': esMX,
  'fr-FR': frFR,
  'it-IT': itIT,
  'ja-JP': jaJP,
  'ko-KR': koKR,
  'pt-BR': ptBR,
  'zh-CN': zhCN,
  'zh-HK': zhHK,
  'de-AT': deAT,
  'de-DE': deDE
};

export const getTranslations = (locale = 'en-GB'): any => {
  return localeMap[locale] || localeMap['en-GB'];
};

export default {
  getTranslations
};
